import { HTML_CONTENT_PATTERN } from '../editor.constant';

const BLOCK_TAGS = new Set([
  'P',
  'OL',
  'UL',
  'DIV',
  'H1',
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  'BLOCKQUOTE',
]);

export function isHtmlContent(text: string): boolean {
  return HTML_CONTENT_PATTERN.test(text);
}

/**
 * Returns true when every top-level node is a block element — no raw text
 * mixed in. This distinguishes pure Quill HTML (all <p>/<ol>) from template
 * output that mixes plain text lines with HTML fragments.
 */
export function isWellFormedHtml(text: string): boolean {
  if (!/<p[\s>]/i.test(text)) {
    return false;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  const children = Array.from(doc.body.childNodes);

  return children.every((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      return !node.textContent?.trim();
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      return BLOCK_TAGS.has((node as Element).tagName);
    }

    return true;
  });
}
